import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Capabilities', href: '#capabilities' },
  { label: 'Who We Serve', href: '#who-we-serve' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Teaming', href: '#teaming' },
  { label: 'Contact', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToSection = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      data-testid="sticky-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-black/70 backdrop-blur-xl border-b border-white/10 shadow-lg'
          : 'bg-black/30 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center gap-2"
          data-testid="logo"
        >
          <img
            src="/logo-transparent.png"
            alt="Cole Utilities"
            className="h-12 w-auto"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollToSection(link.href)}
              className="font-body text-[13px] text-[#A3A3A3] hover:text-white transition-colors duration-200 tracking-wide uppercase"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Button
            data-testid="header-cta-btn"
            onClick={() => scrollToSection('#contact')}
            className="bg-[#B8102E] text-white hover:bg-[#97021C] font-body font-semibold text-sm px-6 rounded-full transition-all duration-300 btn-sweep"
          >
            Get in Touch
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6"
        >
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollToSection(link.href)}
              className="block w-full text-left py-3 font-body text-[#A3A3A3] hover:text-white transition-colors text-sm uppercase tracking-wide"
            >
              {link.label}
            </button>
          ))}
          <Button
            data-testid="mobile-cta-btn"
            onClick={() => scrollToSection('#contact')}
            className="mt-4 w-full bg-[#B8102E] text-white hover:bg-[#97021C] font-body font-semibold rounded-full"
          >
            Get in Touch
          </Button>
        </div>
      )}
    </header>
  );
}
